import { CREATE_PARAM, CREATE_PARAM_SUCCESSFUL, CREATE_PARAM_FAILED } from './actionTypes';

const initialState = {
    creationPARAMError: null, messagePARAM: null, loadingCreatePARAM: false
}

const createPARAM = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_PARAM:
            state = {
                ...state,
                loadingCreatePARAM: true,
                creationPARAMError: null
            }
            break;
        case CREATE_PARAM_SUCCESSFUL:
            state = {
                ...state,
                loadingCreatePARAM: false,
                messagePARAM: action.payload,
                creationPARAMError: null
            }
            break;
        case CREATE_PARAM_FAILED:
            state = {
                ...state,
                messagePARAM: null,
                loadingCreatePARAM: false,
                creationPARAMError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default createPARAM;